import React from 'react';
import { Box, Typography } from '@material-ui/core';

/**
 * Question Title Component
 * Displays form question titles with required indicator and missing field highlighting
 */
function QuestionTitle(props) {
  const {
    title,
    subTitle,
    required = false,
    isMissing = false,
    classes,
  } = props;

  const titleRenderer = (titleText, isRequired = false, isMissingField = false) => {
    const titleClass = classes
      ? (isMissingField ? classes.questionTitleMissing : classes.questionTitle)
      : undefined;
    const requiredMarkClass = classes?.requiredMark;

    if (!isRequired) {
      return <Typography className={titleClass} variant={'h5'}>{titleText}</Typography>;
    }
    return (
      <Box display={'flex'} alignItems={'center'}>
        <Typography
          className={requiredMarkClass || undefined}
          color={requiredMarkClass ? undefined : 'error'}
          variant={'h5'}
        >
          *
        </Typography>
        <Typography
          className={titleClass}
          color={(!classes && isMissingField) ? 'error' : undefined}
          variant={'h5'}
        >
          {titleText}
        </Typography>
      </Box>
    );
  };

  return (
    <Box width={'100%'} display={'flex'} flexDirection={'column'}>
      {titleRenderer(title, required, isMissing)}
      {subTitle && <Typography className={classes?.questionTitle} variant={'h6'}>{subTitle}</Typography>}
    </Box>
  );
}

export default QuestionTitle;
